/* eslint-disable no-case-declarations */
import * as types from '../types/video-resource.type';

interface Action {
  type: string;
  payload?: any;
}

const initialState = (() => ({
  videoResourceList: {
    list: [],
    page: {
      size: 10, // 因为每行要么显示4个，要么显示3个，所以每页显示12个
      number: 1,
      totalPages: 0,
      totalElements: 0,
    },
  },
}))();

const VideoResourceList = (state = { ...initialState }, { type, payload }: Action) => {
  switch (type) {
    case types.GET_VIDEO_RESOURCE_LIST:
      return {
        ...state,
        videoResourceList: payload,
      };
    case types.RESET_LISTS: // 重置列表
      return {
        videoResourceList: {
          ...initialState.videoResourceList,
          page: {
            ...initialState.videoResourceList.page,
          },
        },
      };
    default:
      return {
        ...state,
      };
  }
};
export default VideoResourceList;
